import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import Icon from 'assets/components/icon/Icon';
import TextInput from 'assets/components/inputs/text/TextInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { useLossCodeCategoryProvider } from '../LossCodeCategory.Hooks';

const nameMaxLength = 100;

export default function LossCodeCategoryEdit() {
  const { lang } = getLocales();
  const { selected, pageRouter, saveApi } = useLossCodeCategoryProvider();

  return (
    <>
      <ModalForm<Api.Core.LossCodeCategory.Save.IRequest>
        subcomponents={ThemeModalFormDefault}
        dependencyArray={[selected]}
        title={lang.lossCodeCategory}
        default={selected?.toJSON() || {}}
        onCancel={pageRouter.updateParams}
        onSubmit={(data) => saveApi.execute(data)}
        validation={(data, errors) => {
          if (!data.nameEn) errors.nameEn = lang.mustNotBeEmpty;
          if (!data.nameFr) errors.nameFr = lang.mustNotBeEmpty;
        }}
        render={({ form }) => (
          <>
            <FormWrapper>
              <TextInput
                name="nameEn"
                label={lang.categoryNameEn}
                value={form.data.nameEn}
                error={form.errors.nameEn}
                onChange={form.update}
                maxLength={nameMaxLength}
                icon={<Icon class="if-quill-pen" />}
              />
              <TextInput
                name="nameFr"
                label={lang.categoryNameFr}
                value={form.data.nameFr}
                error={form.errors.nameFr}
                onChange={form.update}
                maxLength={nameMaxLength}
                icon={<Icon class="if-quill-pen" />}
              />
            </FormWrapper>
          </>
        )}
      />
    </>
  );
}
